<template>
<div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'ShippingMethodList' }">Shipping Methods</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form
    ref="shipping_method"
    :rules="rules.shipping_method"
    :model="shipping_method"
    :label-position="label_position">

        <el-form-item label="Name" prop="name">
            <el-input v-model="shipping_method.name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
            <el-input v-model="shipping_method.description"></el-input>
        </el-form-item>
        <el-form-item label="Tracking URL" prop="tracking_url">
            <el-input v-model="shipping_method.tracking_url"></el-input>
        </el-form-item>
        <el-form-item label="Support E-Mail" prop="support_email">
            <el-input v-model="shipping_method.support_email"></el-input>
        </el-form-item>
        <el-form-item label="Support Number" prop="support_number">
            <el-input v-model="shipping_method.support_number"></el-input>
        </el-form-item>
        <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0" v-model="shipping_method.sort_order"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addShippingMethod('shipping_method')">Add</el-button>
        </el-form-item>

   </el-form>

  <pre v-if="config.debug">{{$data}}</pre>

</div>
</template>

<style>

</style>

<script>

    import Config from '@/store/Config.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Shipping Method',
                page_slug: 'add-shipping-method',
                label_position: 'top',
                loading: false,
                rules: {
                    shipping_method: {
                        name: [
                            {required: true, message: 'Please Enter Corporation Name', trigger: 'blur'}
                        ],
                        description: [
                            {required: true, message: 'Please Enter Description', trigger: 'blur'}
                        ],
                        tracking_url: [
                            {required: true, message: 'Please Enter URL', trigger: 'blur'},
                            {type: 'url', message: 'Please Enter Valid URL', trigger: 'blur'}
                        ],
                        support_email: [
                            {required: true, message: 'Please Enter E-Mail', trigger: 'blur'},
                            {type: 'email', message: 'Please Enter Valid E-Mail', trigger: 'blur'}
                        ],
                        support_number: [
                            {required: true, message: 'Please Enter Support Number', trigger: 'blur'},
                        ],
                        sort_order: [
                            {required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                            {type: 'integer', message: 'Please Enter Number', trigger: 'blur'}
                        ],
                    }
                },

                shipping_method: {
                    name: '',
                    description: '',
                    tracking_url: '',
                    support_email: '',
                    support_number: '',
                    sort_order: '',
                },
            };  
        },

        mounted: function() {
            const me = this;
        },

        methods: {
            addShippingMethod: function(formName) {
                console.log('Add Shipping Method Function');
                const me = this;
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    me.$http.post(me.config.api + 'shippingMethods', me.shipping_method).then(
                        response => {
                        console.log('success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        // Success notification 
                        me.$notify({
                            title: 'Success',
                            message: 'The Shipping Method Was Added',
                            type: 'success'
                        });
                        // Reset the form to prevent double submissions 
                        me.resetForm(formName);
                        // Redirect to the list page
                        me.$router.push({ name: 'ShippingMethodList'});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/shipping-methods/ShippingMethodAdd.vue